@if(perfil != 'posto'){
<section style="height: auto;" translate="no">
    <nav>
        <ol class="divbusca">
            <div class="div_busca_orientacao">
                <div class="item_pesquisa">
                    <div class="tdTitilo">
                        <label for="regiao" class="form-label">Região:</label>
                    </div>
                    <div class="tdCampo">
                        <select (change)="onSelecionar(mySelectFiltroRegiao.value)" #mySelectFiltroRegiao name="select"
                            aria-placeholder="Regiao" class="form-select">
                            <option value=""></option>
                            <option *ngFor="let objeto of listaRegiao" value={{objeto.id}}>{{objeto.descricao}}
                            </option>

                        </select>
                    </div>
                </div>
                <div class="item_pesquisa">
                    <div class="tdTitilo">
                        <label for="posto" class="form-label">Posto:</label>
                    </div>
                    <div class="tdCampo">
                        <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/porcentagemDaTela"
                            [regiaoSelecionada]="RegiaoSelecionada"
                            (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
                    </div>
                </div>
                <div class="tdTitilo">
                    <button class="btn btn-primary btnpesquisa" (click)="filtrarPesquisa()" id="class-button"
                        type="submit">Pesquisar</button>
                </div>
            </div>
        </ol>
    </nav>
</section>
}
@if(perfil != 'posto'){
@if(feitaPesquisa)
{
<h4 class="alerta_busca" translate="no">Escolha um posto para visualizar o quadro de vagas
</h4>
}
}
<div class="container" style="margin-left: 0px;margin-right: 1%;" translate="no">
    @for(item of resultado; track resultado; let indexResultado = $index){
    @if(newFilter.length > 0){
    @for(filtro of newFilter; track filtro;){
    @if(item.idPosto == filtro.codigoCentralizado){
    <ul class="ul_relatorio">
        <li>
            <div class="gh-table">
                <div id="gridHeat" style="width: 100%;  max-width: 100vw;">
                    <div class="div-title tooltip">
                        <div>
                            <h4 class="card-title">{{ item.nomePosto }}</h4>
                        </div>
                    </div>
                    <div class="div-value" style="height: 500px;">
                        <div class="gh-row">
                            <div class="gh-cell">
                              <div style="cursor: pointer;" (click)="ordenarPorOrgao()">
                                <div class="gh-value">
                                  Órgão
                                  <span>
                                    {{ campoOrdenado === 'orgao' ? (ordem === 'asc' ? '▲' : '▼') : '⇅' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          
                            <div class="gh-cell">
                              <div style="cursor: pointer;" (click)="ordenarPorServico()">
                                <div class="gh-value">
                                  Serviço
                                  <span>
                                    {{ campoOrdenado === 'servico' ? (ordem === 'asc' ? '▲' : '▼') : '⇅' }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          
                            @for (datas of listaDatas; track datas) {
                              <div class="gh-cell" style="position: sticky !important;">
                                <div style="background-color: rgb(238, 238, 238); cursor: pointer;" (click)="ordenarPorData(datas)">
                                  <div class="gh-value">
                                    {{ datas }}
                                    <span>
                                      {{ campoOrdenado === datas ? (ordem === 'asc' ? '▲' : '▼') : '⇅' }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        @for(obj of item.listaOrgaoServico; track obj; let indexLine = $index){
                        <div class="gh-row">
                            @if(obj[2]){
                            @if(obj[2].length > 0){
                            @for (valores of obj[2]; track valores; let indexCol = $index) {
                            @if(indexCol == 0){
                            <div class="gh-cell rowLabel"
                                style="min-width: 70px; left: 0px; background-color: rgb(238, 238, 238);">
                                @if(validarOrgaoAtual(obj[1].trim()) == true){
                                <span class='gh-value'>
                                    {{ obj[1].trim() }}
                                </span>
                                }@else{
                                <span class='gh-value'></span>
                                }
                            </div>
                            <div class="gh-cell rowLabel"
                                style="min-width: 200px;left: 84px; width: 300px; background-color: rgb(238, 238, 238);">
                                <span class='gh-value'>{{ obj[0] }}</span>
                            </div>
                            }
                            @if(indexCol < 30){ @if(veririficarValores(valores)==true){ <div class="gh-cell">
                                <span></span>
                        </div>
                        }@else {
                        <div class="gh-cell" [style.background]="paint(valores)">
                            <span class="gh-value">
                                {{valores.v}}
                            </span>
                        </div>

                        }
                        }
                        }
                        }
                        }
                    </div>
                    }
                </div>
            </div>
</div>
</li>
</ul>
}
}
}
@else{
<ul class="ul_relatorio" translate="no">
    <li>
        <div class="gh-table">
            <div id="gridHeat" style="width: 100%; max-width: 100vw;">
                <div class="div-title tooltip">
                    <div>
                        <h4 class="card-title">{{ item.nomePosto }}</h4>
                    </div>
                </div>
                <div class="div-value" style="height: 500px;">
                    <div class="gh-row">
                        <div class="gh-cell">
                        </div>
                        <div class="gh-cell"></div>
                        @for (datas of listaDatas; track datas) {
                        <div class="gh-cell" style="position: sticky !important;">
                            <div style="background-color: rgb(238, 238, 238);">
                                <div class="gh-value">{{ datas }}</div>
                            </div>
                        </div>
                        }
                    </div>
                    @for(obj of item.listaOrgaoServico; track obj; let indexLine = $index){
                    <div class="gh-row">
                        @if(obj[2]){
                        @if(obj[2].length > 0){
                        @for (valores of obj[2]; track valores; let indexCol = $index) {
                        @if(indexCol == 0){
                        <div class="gh-cell rowLabel"
                            style="min-width: 70px; left: 0px; background-color: rgb(238, 238, 238);">
                            @if(validarOrgaoAtual(obj[1].trim()) == true){
                            <span class='gh-value'>
                                {{ obj[1].trim() }}
                            </span>
                            }@else{
                            <span class='gh-value'></span>
                            }
                        </div>
                        <div class="gh-cell rowLabel"
                            style="min-width: 200px;left: 84px; width: 300px; background-color: rgb(238, 238, 238);">
                            <span class='gh-value'>{{ obj[0] }}</span>
                        </div>
                        }
                        @if(indexCol < 30){ @if(veririficarValores(valores)==true){ <div class="gh-cell">
                            <span></span>
                    </div>
                    }@else {
                    <div class="gh-cell" [style.background]="paint(valores)">
                        <span class="gh-value">
                            {{valores.v}}
                        </span>
                    </div>

                    }
                    }
                    }
                    }
                    }
                </div>
                }
            </div>
        </div>
        </div>
    </li>
</ul>
}
}
</div>